<template>
  <div class="progress">
    <div class="progress-bar" :style="{width:value}"></div>
  </div>
</template>

<script>
export default {
  name: 'pregress-bar',
  props: {
    value: {
      type: [String, Number],
      default: '50%'
    }
  }
}
</script>

<style scoped lang="scss">
  .progress{
    width: 90px;
    height: 5px;
    border-radius: 2px;
    background: var(--APP_theme_color_colorOpacity3);
    position: relative;
    &-bar{
      position: absolute;
      top: 0;
      left: 0;
      height: 5px;
      border-radius: 2px;
      background: var(--APP_theme_color);
    }
  }
</style>
